import { jsx as e } from "react/jsx-runtime";

import { useRef as r, useCallback as t, useEffect as s } from "react";

import { useSyncExternalStore as a } from "use-sync-external-store/shim";

import o from "../../../utils/classNames/index.js";

import { EMPTY_DATE_VAL as i } from "../constants/index.js";

import n from "../hooks/useGlobals.js";

import { addDays as l, getMonth as m, startOfDay as d } from "../utils/index.js";

// optimizing selectors quantity with bitmasks
const c = ({dayIndex: c}) => {
    const {model: u, formatters: f} = n(), p = r(null), x = t((() => l(u.intendedTsFirstDay, c)), [ c ]), b = a(u.on, x, x), y = m(b), h = d(b), j = t((() => {
        const {intendedTs: e, selectedTs: r, isDateDisabled: t} = u, s = d(e), a = r === i ? -1 : d(r);
        return (t(b) ? 1 : 0) | (h === s ? 4 : 0) | (h === a ? 2 : 0) | (y === m(e) ? 8 : 0);
    }), [ b ]), D = a(u.on, j, j), g = !!(1 & D), T = !!(4 & D), k = !!(2 & D), v = !!(8 & D), w = T && !g;
    return s((() => {
        w && p.current?.focus();
    }), [ w ]), 
    /* @ts-ignore */ e("td", {
        ref: p,
        className: o("py-xs w-full", v ? "" : "italic text-neutral-600", g ? "bg-neutral-200" : "cursor-pointer", T ? "bg-primary-600 text-white" : o(g ? "" : "hover:bg-primary-200", k ? "bg-primary-300" : "")),
        "aria-disabled": "" + g,
        "aria-selected": "" + T,
        tabIndex: T ? 0 : -1,
        "aria-label": f.DayLabel.format(b),
        onClick: g ? void 0 : () => u.select(b),
        children: f.Day.format(b)
    });
};

export { c as default };
//# sourceMappingURL=DayCell.js.map
